import type { ReactNode } from "react";
import useScrollProgress from "./useScrollProgress";

// cada linha com sua palavra de destaque em serif itálica
const LINES: ReactNode[] = [
  <>
    pra quem começa toda <span className="e21-serif">segunda</span> e para na
    terça.
  </>,
  <>
    pra quem é o único do <span className="e21-serif">rolê</span> que quer
    mais.
  </>,
  <>
    pra quem quer <span className="e21-serif">prova</span>, não discurso.
  </>,
  <>
    pra quem tá pronto pra evoluir <span className="e21-serif">junto</span>,
    não sozinho.
  </>,
];

/**
 * seção sticky: as 4 frases empilhadas, e o scroll vai "acendendo"
 * uma por vez (as outras ficam apagadas e levemente desfocadas).
 */
const ForWhom = () => {
  const [sectionRef, progress] = useScrollProgress();

  // respiro no início e no fim do bloco
  const eased = Math.min(1, Math.max(0, (progress - 0.1) / 0.8));
  const active = Math.min(LINES.length - 1, Math.floor(eased * LINES.length));

  return (
    <section ref={sectionRef} className="relative h-[260vh]">
      <div className="sticky top-0 flex h-svh flex-col items-center justify-center px-6">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-black/35">
          o escape21 é
        </span>
        <div className="mt-8 max-w-xl space-y-6 text-center sm:space-y-8">
          {LINES.map((line, i) => {
            const isActive = i === active;
            return (
              <p
                key={i}
                className={`text-2xl font-extrabold leading-snug tracking-[-0.03em] transition-all duration-500 sm:text-4xl ${
                  isActive
                    ? "scale-100 opacity-100 blur-0"
                    : "scale-[0.96] opacity-20 blur-[1.5px]"
                }`}
              >
                {line}
              </p>
            );
          })}
        </div>
        <span className="mt-8 font-mono text-sm tabular-nums text-black/40">
          {active + 1}/4
        </span>
      </div>
    </section>
  );
};

export default ForWhom;
